import { Link } from 'react-router'
import { useThemeColors } from '../hooks/useThemeColors'

export default function NotFound() {
  const c = useThemeColors()
  return (
    <div
      style={{
        minHeight: '100vh',
        background: c.bgPrimary,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        textAlign: 'center',
      }}
    >
      <div style={{ maxWidth: '480px' }}>
        <div
          style={{
            fontFamily: 'JetBrains Mono, monospace',
            fontSize: '11px',
            fontWeight: 500,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: c.signal,
            marginBottom: '16px',
          }}
        >
          404 — PAGE NOT FOUND
        </div>
        <h1
          style={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 800,
            fontSize: '52px',
            letterSpacing: '-0.03em',
            color: c.textPrimary,
            margin: '0 0 16px',
            lineHeight: 1.05,
          }}
        >
          Page not found
        </h1>
        <p
          style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '18px',
            color: c.textMuted,
            maxWidth: '400px',
            margin: '0 auto 32px',
            lineHeight: 1.6,
          }}
        >
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            background: 'transparent',
            border: `1px solid ${c.border}`,
            borderRadius: '2px',
            padding: '10px 24px',
            fontFamily: 'Inter, sans-serif',
            fontSize: '15px',
            fontWeight: 500,
            color: c.textMuted,
            textDecoration: 'none',
            transition: 'border-color 150ms, color 150ms',
          }}
          onMouseEnter={e => {
            const el = e.currentTarget as HTMLElement
            el.style.borderColor = c.signal
            el.style.color = c.textPrimary
          }}
          onMouseLeave={e => {
            const el = e.currentTarget as HTMLElement
            el.style.borderColor = c.border
            el.style.color = c.textMuted
          }}
        >
          Back to home
        </Link>
      </div>
    </div>
  )
}
